import React, { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { D1ToastCloseButton, D1ToastIcon, normalizeD1ToastVariant } from './D1Toast';

const Toast: FC = (): JSX.Element => {
  return (
    <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar
      newestOnTop
      style={{ zIndex: 10500 }}
      closeButton={({ closeToast, type }) => (
        <D1ToastCloseButton
          variant={type}
          onClick={(event) => {
            closeToast(event);
          }}
        />
      )}
      icon={({ type }) => <D1ToastIcon variant={type} />}
      toastClassName={({ defaultClassName, type }) =>
        `${defaultClassName || ''} d1-toast d1-toast--${normalizeD1ToastVariant(type)}`.trim()
      }
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
    />
  );
};

export default Toast;
